import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {UPPERCASE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Driver's Last Name text field.
 * Uppercases and sanitizes input on every keystroke.
 */
const DriverLastNameField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('driverLastName', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="driverLastName"
      name="driverLastName"
      label="Driver's Last Name"
      value={value}
      onChange={handleChange}
      placeholder="Enter the driver's last name"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...UPPERCASE_INPUT_PROPS, 'aria-label': "Driver's Last Name"}}
    />
  );
};

export default DriverLastNameField;

